// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondary":"#33C370","secondaryLight":"#7FE7AB","textDefault":"#808080","wrapper":"llcunAdmStEjlvTP0rYcP","container":"_1BHO7dbixZsP_pEhuE-EG5","active":"PwQEb1bcDC7Ezdyxj1641","title":"jWYmend_oENJ3RYXkox5n","text":"_1v2vvjpFzB9qlUFH_CkxT-","heading":"_2xtE17ha4ziUIq9YOn9Vnq","date":"_1JdWFW8AmOObIdaISQeFKq","time":"ifQPRas442k3TeMC-1AR0","shrinked-component":"_2Pq9CagDdGYCd8sbV7xSbC"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Journal/components/NoteBlock.mod.css
// module id = 1790
// module chunks = 0